"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable-next-line: max-line-length
var Recurrence_1 = require("./Recurrence");
var StaticInitializers;
(function (StaticInitializers) {
    StaticInitializers.DEFAULT_DAY_OF_MONTH_ARR = function () { return [new Date().getDate()]; };
    StaticInitializers.DEFAULT_DAY_OF_MONTH_STR = function () { return Recurrence_1.RecurrenceConverters.toDaysOfMonthMask(StaticInitializers.DEFAULT_DAY_OF_MONTH_ARR()) + ''; };
    StaticInitializers.DEFAULT_ALL_DAYS_A_WEEK = function () { return [Recurrence_1.RecurrenceDaysOfTheWeek.Sun, Recurrence_1.RecurrenceDaysOfTheWeek.Mon,
        Recurrence_1.RecurrenceDaysOfTheWeek.Tue, Recurrence_1.RecurrenceDaysOfTheWeek.Wed, Recurrence_1.RecurrenceDaysOfTheWeek.Thu, Recurrence_1.RecurrenceDaysOfTheWeek.Fri,
        Recurrence_1.RecurrenceDaysOfTheWeek.Sat]; };
    StaticInitializers.DEFAULT_WEEKDAYS = function () { return Recurrence_1.RecurrenceConverters.getDayOfWeek(new Date()); };
    StaticInitializers.MINUTES_IN_HOUR = 60;
    StaticInitializers.HOURS_IN_DAY = 24;
    StaticInitializers.MINUTES_IN_DAY = StaticInitializers.MINUTES_IN_HOUR * StaticInitializers.HOURS_IN_DAY;
    StaticInitializers.MAX_DAYS_IN_A_MONTH = 31;
    StaticInitializers.NumberOfRecurrenceDaysOfTheWeek = 7;
    StaticInitializers.RoundToNearest = function (value, roundToNearest) { return Math.round(value / roundToNearest) * roundToNearest; };
    StaticInitializers.RoundToNext = function (value, roundToNext) { return Math.floor(value / roundToNext) * roundToNext + roundToNext; };
    StaticInitializers.DEFAULT_START_TIME = function (roundToNext) {
        roundToNext = roundToNext || 5;
        var minutes = new Date().getHours() * StaticInitializers.MINUTES_IN_HOUR + new Date().getMinutes();
        return StaticInitializers.RoundToNext(minutes, roundToNext);
    };
    StaticInitializers.DEFAULT_END_TIME = StaticInitializers.DEFAULT_START_TIME;
    function defaultRecurrence(roundToNext) {
        return {
            // recurrenceMode: RecurrenceModes.DataRefresh,
            recurrenceMode: Recurrence_1.RecurrenceMode.TimeRecurrence,
            recurrenceType: Recurrence_1.RecurrenceType.Daily,
            recurrenceDetails: defaultDaily(roundToNext)
        };
    }
    StaticInitializers.defaultRecurrence = defaultRecurrence;
    function defaultHourly(roundToNext) {
        return {
            startTime: StaticInitializers.DEFAULT_START_TIME(roundToNext),
            endTime: StaticInitializers.DEFAULT_END_TIME(roundToNext),
            recurrenceMinutes: StaticInitializers.MINUTES_IN_HOUR,
            recurrenceDaysOfWeek: StaticInitializers.DEFAULT_WEEKDAYS()
        };
    }
    StaticInitializers.defaultHourly = defaultHourly;
    function defaultDaily(roundToNext) {
        return {
            startTime: StaticInitializers.DEFAULT_START_TIME(roundToNext),
            endTime: StaticInitializers.DEFAULT_END_TIME(roundToNext),
            recurrenceMinutes: StaticInitializers.MINUTES_IN_DAY,
            recurrenceDaysOfWeek: StaticInitializers.DEFAULT_WEEKDAYS()
        };
    }
    StaticInitializers.defaultDaily = defaultDaily;
    function defaultWeekly(roundToNext) {
        return {
            startTime: StaticInitializers.DEFAULT_START_TIME(roundToNext),
            recurrenceDaysOfWeek: StaticInitializers.DEFAULT_WEEKDAYS()
        };
    }
    StaticInitializers.defaultWeekly = defaultWeekly;
    function defaultMonthly(roundToNext) {
        return {
            startTime: StaticInitializers.DEFAULT_START_TIME(roundToNext),
            recurrenceDayOfMonth: StaticInitializers.DEFAULT_DAY_OF_MONTH_STR(),
            recurrenceDaysOfWeek: null
        };
    }
    StaticInitializers.defaultMonthly = defaultMonthly;
})(StaticInitializers = exports.StaticInitializers || (exports.StaticInitializers = {}));
//# sourceMappingURL=StaticInitializers.js.map